/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CategoryGradeResultGrade } from './categoryGradeResultGrade';

/**
 * Per-category grade contribution for a module grade preview.
 */
export interface CategoryGradeResult {
  id: string;
  label: string;
  grade: CategoryGradeResultGrade;
  evaluated: number;
}
